// extracted by mini-css-extract-plugin
export default {"contractCell":"MissingContractRoleWorklistPage_contractCell__VJeHn","contractName":"MissingContractRoleWorklistPage_contractName__0JKqT"};